<div class="notification-management-container" *ngIf="!isLabelsLoading">
	<div class="header-wrap">
		<span class="tab" [ngClass]="{ selected: selectedNotification == undefined }" (click)="selectedNotification = undefined">{{
			labels.lbl_geral_gerenciamento_notificacao
		}}</span>
		<span class="tab" [ngClass]="{ selected: selectedNotification != undefined }" *ngIf="selectedNotification != undefined">{{
			selectedNotification.summary
		}}</span>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="selectedNotification == undefined">
			<div class="form-wrap">
				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_titulo }}</span>
					<input [value]="filter.summary" (input)="filter.summary = $event.target.value" />
				</div>

				<div class="dotted-input-container">
					<span>{{ labels.lbl_geral_tipo_notificacao }}</span>
					<select (change)="filter.type = $event.target.value">
						<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
						<option [value]="'Announcement'">{{ labels.lbl_geral_anuncio }}</option>
						<option [value]="'Important'">{{ labels.lbl_geral_importante }}</option>
						<option [value]="'News'">{{ labels.lbl_geral_novidade }}</option>
						<option [value]="'Urgent'">{{ labels.lbl_geral_urgent }}</option>
					</select>
				</div>

				<div class="button-container">
					<div class="button" (click)="addNewNotification()">{{ labels.lbl_geral_novo }}</div>
					<div class="button" [ngClass]="{ disabled: isNotificationsLoading }" (click)="searchNotifications()">
						{{ labels.lbl_geral_buscar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isNotificationsLoading"></cpi-dot-bounce-loading-effect>
					</div>
				</div>
			</div>

			<cpi-msp-table
				[header]="searchHeader"
				[body]="notifications"
				[height]="'33dvh'"
				[labels]="labels"
				[insideSort]="true"
				[tableOnly]="true"
				(getSelectedItem)="selectNotification($event)"
				(getSelectedItemIndex)="selectedIndex = $event"
				*ngIf="notifications.length > 0">
			</cpi-msp-table>
		</ng-container>

		<ng-container *ngIf="selectedNotification != undefined">
			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_titulo }}*</span>
				<input [value]="selectedNotification.summary" (input)="selectedNotification.summary = $event.target.value" />
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_tipo_notificacao }}</span>
				<select [(ngModel)]="selectedNotification.type">
					<option [value]="'Announcement'">{{ labels.lbl_geral_anuncio }}</option>
					<option [value]="'Important'">{{ labels.lbl_geral_importante }}</option>
					<option [value]="'News'">{{ labels.lbl_geral_novidade }}</option>
					<option [value]="'Urgent'">{{ labels.lbl_geral_urgent }}</option>
				</select>
			</div>

			<div class="dotted-input-container">
				<span>{{ labels.lbl_geral_cliente }}</span>
				<select [(ngModel)]="selectedNotification.customer">
					<option [value]="''">{{ labels.lbl_geral_selecione }}</option>
					<option *ngFor="let option of customers" [value]="option.customer">{{ option.customer }}</option>
				</select>
			</div>

			<div class="dotted-input-container">
				<span class="label">
					<span>{{ labels.lbl_geral_data_limite2 }}*</span>
					<span class="label-tip" [title]="labels.lbl_geral_formato_data_limite_aaaaMMdd_HHmm"
						><fa-icon [icon]="icons.faQuestionCircle"></fa-icon
					></span>
				</span>
				<input [value]="selectedNotification.limit_date" (input)="selectedNotification.limit_date = $event.target.value" />
			</div>

			<div class="input-container">
				<span class="label">{{ labels.lbl_geral_detalhamento }}*</span>
				<angular-editor [config]="editorConfig" [(ngModel)]="selectedNotification.description"> </angular-editor>
			</div>

			<div class="button-container">
				<div class="button" (click)="selectedNotification = undefined; isNotificationsLoading = false">
					{{ labels.lbl_geral_voltar }}
				</div>
				<div
					class="button"
					*ngIf="selectedNotification.id != '-1'"
					(click)="
						confirmDeleteField.classList.contains('confirmClick') ? deleteNotification() : confirmButton(confirmDeleteField)
					"
					#confirmDeleteField>
					{{ labels.lbl_geral_excluir }}
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingNotification }"
					(click)="createNotification()"
					*ngIf="selectedNotification.id === '-1'">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingNotification"></cpi-dot-bounce-loading-effect>
				</div>
				<div
					class="button"
					[ngClass]="{ disabled: isUpdatingNotification }"
					(click)="updateNotification()"
					*ngIf="selectedNotification.id != '-1'">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingNotification"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLabelsLoading" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
